import { ActivatedRoute, Router } from '@angular/router';
import { PaymentBaseData, PaymentProperties, PaymentDocDetailsProperties, FileDownloadType, PaymentRightsProperties, NewPaymentRequest, PaymentResponseMessage, GatewayURLSCProps } from '../Models/PaymentProperties';
import { ActiveDepositType, ActiveModeOfPayment, ActiveBenificaryAccount } from '../Models/ActiveClasses';
import { PaymentService } from '../Services/payment.service';
import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { environment } from '../../environments/environment';
import { saveAs as importedSaveAs } from "file-saver";
import { UrlRequest } from '../Models/AgencyMasterProperties';
import { Location } from '@angular/common';
import { AgencyService } from '../Services/Agency.service';
import { CompanyMasterProperties } from '../Models/CompanyMasterProperties';
import *as HmacSHA256 from 'crypto-js/hmac-sha256';
import *as Base64 from "crypto-js/enc-base64";
import * as moment from 'moment-timezone';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { ERPBackOffliceBankList } from '../Models/BeneficiaryAccountProperties';
import { DomSanitizer } from '@angular/platform-browser';
declare var $;

@Component({
  selector: 'app-payment-add-edit',
  templateUrl: './payment-add-edit.component.html',
  styleUrls: ['./payment-add-edit.component.css']
})
/** PaymentAddEdit component*/
export class PaymentAddEditComponent {
  startDisabled: boolean = true;
  clientDisabled: boolean = true;
  bankDisabled: boolean = false;
  startDisabledFields: boolean = true;
  disabledField: boolean = false;
  hideIPGFields: boolean = true;
  buttonIPGClick: boolean = false;
  baseData = new PaymentBaseData();
  obj = new PaymentProperties();
  myFiles: string[] = [];
  getPaymentRequest = new NewPaymentRequest();
  modeOfPayments: ActiveModeOfPayment[] | undefined;
  benificaryAccount: ActiveBenificaryAccount[] | undefined;
  newPaymentSubmitted: boolean = false;
  depositTypesList: ActiveDepositType[] | undefined;
  primeShowModalSavePaymentModel: boolean = false;
  primeShowModalSuccessModel: boolean = false;
  primeShowModalApprovePaymentModel: boolean = false;
  primeShowModalRejectPaymentModel: boolean = false;
  primeShowModalCreditCardPaymentModel: boolean = false;
  primeShowModalCreditCardPaymentSuccessModel: boolean = false;
  primeShowModalCreditCardPaymentFailModel: boolean = false;
  primeShowModalDisplayImage: boolean = false;
  loaderConfimVar: boolean = false;
  paymentResponseMessage = new PaymentResponseMessage();
  showApproveRejectPaymentButton: boolean = false;
  showRejectPaymentButton: boolean = false;
  managercheck: boolean = false;
  rightsObj = new PaymentRightsProperties();
  clearSetTimeOut: any;
  backSystemCompanies: CompanyMasterProperties[] | undefined;
  private requestURL = new UrlRequest();
  erpLoader: boolean = false;
  backOfficeBranchList: ERPBackOffliceBankList[] | undefined;;
  detailList = [];
  listObj = new PaymentDocDetailsProperties();
  ValidateFileFormat: boolean = false;
  requesterImmediateParent: string;
  urls = new GatewayURLSCProps();
  datetimenew: string = "";
  snapShotRoute: string;
  snapShotRouteId: string;
  isSnapShotRoute: boolean = false;
  imagePreview: any;
  currentDate: any;
  originalReference: string;
  showApprovedorRejectedBy: boolean = false;
  @ViewChild('mainDiv', { static: false }) mainDiv !: ElementRef;


  constructor(private service: PaymentService, private previousLocation: Location
    , private router: Router, private agencyService: AgencyService,
    private activatedRoute: ActivatedRoute,private senetizer: DomSanitizer) {
  }
  @HostListener('window:unload', ['$event'])
  unloadHandler(event) {
    this.obj.inProcess = false;
    if ((this.managercheck == true) && (this.obj.status == "Requested")) {
      this.service.UpdateInprocessTag(this.obj).subscribe(() => { })
    }
    if (this.snapShotRoute != undefined && this.snapShotRoute != null && this.snapShotRoute != "") {
      if (this.snapShotRoute == "Fail") {
        if (this.snapShotRouteId != undefined && this.snapShotRouteId != null && this.snapShotRouteId != "") {
          this.DeletePayment(this.snapShotRouteId);
        }
      }
    }
    if (this.buttonIPGClick == false && this.obj.modeOfPaymentId == 4) {
      this.CancelCreditCardPayment();
    }

  }
  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event) {
    this.obj.inProcess = false;
    if ((this.managercheck == true) && (this.obj.status == "Requested")) {
      this.service.UpdateInprocessTag(this.obj).subscribe(() => { })
    }
    if (this.snapShotRoute != undefined && this.snapShotRoute != null && this.snapShotRoute != "") {
      if (this.snapShotRoute == "Fail") {
        if (this.snapShotRouteId != undefined && this.snapShotRouteId != null && this.snapShotRouteId != "") {
          this.DeletePayment(this.snapShotRouteId);
        }
      }
    }
    if (this.buttonIPGClick == false && this.obj.modeOfPaymentId == 4) {
      this.CancelCreditCardPayment();
    }
  }
  public DivToPrint = (): void => {

    const pdf = new jsPDF()
    const options = { background: 'white', scale: 3 };
    html2canvas(this.mainDiv.nativeElement, options).then((canvas) => {
      const contentDataURL = canvas.toDataURL('image/png');
      const imgWidth = 210;
      const imgHeight = canvas.height * imgWidth / canvas.width;
      pdf.addImage(contentDataURL, 'PNG', 0, 0, imgWidth, imgHeight);
      pdf.save(`Payment_${this.obj.paymentId}`);
    });

  }
  ngOnInit(): void {
    try {
      this.snapShotRoute = this.activatedRoute.snapshot.params['response'];
      this.snapShotRouteId = this.activatedRoute.snapshot.params['id'];
      if (this.snapShotRoute != undefined && this.snapShotRoute != null && this.snapShotRoute != "") {
        this.isSnapShotRoute = true;
        if (this.snapShotRoute == "Success") {
          this.primeShowModalCreditCardPaymentSuccessModel = true;
        }
        else if (this.snapShotRoute == "Fail") {
          this.primeShowModalCreditCardPaymentFailModel = true;
        }
      }
      else {
        this.requesterImmediateParent = localStorage.getItem("ImmediateParent");
        this.obj.requesterImmediateParent = this.requesterImmediateParent;
        this.isSnapShotRoute = false;
        this.LoadBaseData();
        this.CurrentDate();
        this.CheckPaymentRights();
        this.GetIPGsURL();
        this.getPaymentRequest = this.service.GetRequestData();
        if (this.getPaymentRequest.newPaymentRequest == false) {
          this.ClearBack();
        }
        else if (this.getPaymentRequest.paymentTypeId > 0) {
          this.GetPaymentById(this.getPaymentRequest.paymentTypeId);
        }
      }


    } catch (ex) {
      console.log(ex);
    }
  }
  private CurrentDate = (): void => {
    let date = new Date();
    let todayDate: any = date.getDate();
    let month: any = date.getMonth() + 1;
    let year = date.getFullYear();
    if (todayDate < 10) {
      todayDate = "0" + todayDate;
    }
    if (month < 10) {
      month = "0" + month;
    }
    this.currentDate = year + "-" + month + "-" + todayDate;

  }
  ngOnDestroy(): void {
    if (this.snapShotRoute != undefined && this.snapShotRoute != null && this.snapShotRoute != "") {
      if (this.snapShotRoute == "Fail") {
        if (this.snapShotRouteId != undefined && this.snapShotRouteId != null && this.snapShotRouteId != "") {
          this.DeletePayment(this.snapShotRouteId);
        }
      }
    }
    if (this.clearSetTimeOut) {
      clearTimeout(this.clearSetTimeOut);
    }
    if (this.obj.paymentId > 0 && (this.getPaymentRequest.paymentOpenFrom.includes("managerList") == true)) {
      this.obj.inProcess = false;
      this.service.UpdateInprocessTag(this.obj).subscribe(() => {
      });
    }
    if (this.buttonIPGClick == false && this.obj.modeOfPaymentId == 4) {
      this.CancelCreditCardPayment();
    }
  }
  private DeletePayment = (paymentId: string): void => {
    this.service.DeletePayment(paymentId).subscribe(() => {
      this.primeShowModalCreditCardPaymentFailModel = false;
      this.router.navigateByUrl("/paymentList");
    })
  }
  public ClearBack = (): void => {
    this.previousLocation.back();
  }
  private CheckPaymentRights = (): void => {
    this.service.CheckPaymentRights(localStorage.getItem('AgencyId'), localStorage.getItem('UserId')).subscribe((data) => {
      this.rightsObj = data;
    });
  }
  private LoadBaseData = (): void => {
    try {
      this.agencyService.GetCompanyMaster().subscribe(data => {
        this.backSystemCompanies = data;
      });
      this.service.getPaymentBaseData(localStorage.getItem("AgencyId")).subscribe((data) => {
        this.baseData = data;
        this.modeOfPayments = data.modeOfPayments;
        if (this.modeOfPayments.length > 0) {
          if (this.getPaymentRequest.paymentModeTypeId > 0 && this.getPaymentRequest.paymentTypeId == 0) {
            this.obj.modeOfPaymentId = this.getPaymentRequest.paymentModeTypeId
          }
        }
        this.depositTypesList = data.depositTypes;
        this.benificaryAccount = data.accounts;
      });
    } catch (ex) { }
  }
  private GetPaymentById = (paymentTypeId: number): void => {
    this.service.GetPaymentById(paymentTypeId).subscribe((response) => {
      this.obj = response;
      if (this.obj.paymentId > 0) {
        if (this.getPaymentRequest.paymentOpenFrom.includes("managerList") == true) {
          this.originalReference = this.obj.documentReference;
          this.service.getPaymentBaseData(this.obj.agencyId).subscribe((data) => {
            this.benificaryAccount = data.accounts;
            
          });
        }
        this.requesterImmediateParent = this.obj.requesterImmediateParent;
        if (this.obj.backSystemCompanyId > 0) {
          this.GetERPBackOfficeBranchList(this.obj.backSystemCompanyId);
        }
        if (this.getPaymentRequest.paymentOpenFrom.includes("managerList") == true) {
          this.showApprovedorRejectedBy = true;
        }
        if ((this.obj.status.includes("Requested") == true) && (this.rightsObj.approvePayment == true) && (this.getPaymentRequest.paymentOpenFrom.includes("managerList") == true)) {
          this.showApproveRejectPaymentButton = true;
          this.obj.inProcess = true;
          this.managercheck = true;
          this.clientDisabled = false;
          this.bankDisabled = false;
          this.service.UpdateInprocessTag(this.obj).subscribe(() => { });
          this.clearSetTimeOut = setTimeout(() => {
            this.ClearBack();
          }, 600000)
        }
        else {
          this.clientDisabled = true;
          this.bankDisabled = true;
          this.showApproveRejectPaymentButton = false;
        }
      }

      this.disabledField = true;
      this.obj.docList = response.docList;
      if (this.obj.docList.length > 0) {
        for (let i = 0; i < this.obj.docList.length; i++) {
          var idxDot = this.obj.docList[i].attachmentName.lastIndexOf(".") + 1;
          var extFile = this.obj.docList[i].attachmentName.substr(idxDot, this.obj.docList[i].attachmentName.length).toLowerCase();
          if (extFile == 'pdf') {

            this.obj.docList[i].fileextension = "PDF";
          }
          else if (extFile == 'jpg' || extFile == 'png' || extFile == 'jpeg') {
            this.obj.docList[i].fileextension = "Image";
          }
        }

      }
    });
  }
  public GetERPBackOfficeBranchList = (backSystemCompanyId: number): void => {
    try {
      if (backSystemCompanyId != 0 && backSystemCompanyId != null && backSystemCompanyId != undefined) {

        const filterComapny = this.backSystemCompanies.find(id => id.companyId == backSystemCompanyId);
        if (filterComapny) {
          this.erpLoader = true;
          this.requestURL.request = filterComapny.companyURL;
          this.service.GetERPBackOfficeBranchList(this.requestURL).subscribe(data => {
            this.backOfficeBranchList = data;
            this.erpLoader = false;
            if (this.backOfficeBranchList != null && this.backOfficeBranchList != undefined) {
              this.startDisabledFields = false;
            }
          });
        }
      }
      else {
        this.backOfficeBranchList = null;
        this.startDisabledFields = true;
      }
    }
    catch (ex) {

      console.log(ex)
    }
  }
  public AssigneGLAccountNumber = (branch: string): void => {
    if (branch != "" && branch != null && branch != undefined) {
      const glAccount = this.backOfficeBranchList.find(x => x.bankName == branch);
      if (glAccount) {
        this.obj.glAccountNumber = glAccount.glAccountNumber;
        this.obj.glAccountName = glAccount.glAccountName;
        this.obj.backSystemBranchLocationId = glAccount.bankId;
        this.obj.backSytemBranchLocation = glAccount.branchLocation;
      }
    }
    else {
      this.obj.glAccountNumber = "";
      this.obj.glAccountName = "";
      this.obj.backSytemBranchLocation = "";
      this.obj.backSystemBranchLocationId = 0;
    }
  }
  public SetPaymentDate = (date: any): void => {
    if (date.target.value == "") {
      this.obj.paymentDate = undefined;
    }
    else if (new Date(date.target.value) > new Date(this.currentDate)) {
      date.target.value = this.currentDate;
      this.obj.paymentDate = this.currentDate;
    }
    else {
      this.obj.paymentDate = date.target.value;
    }


  }
  public OnDragOver(event: any): void {
    event.preventDefault();
  }
  public GetFileDetails(event: any, eventTrigger: string): boolean {
    this.myFiles = [];
    this.detailList = [];
    this.obj.docList = [];
    event.preventDefault();
    if (eventTrigger == "click") {
      const files = event.target.files;
      if (files.length == 0) {
        return false;
      }
      else {
        for (let i = 0; i < files.length; i++) {
          const filename = event.target.files[i].name;
          if (this.ValidateFileType(filename) == false) {
            document.getElementById("newPaymentFilesError").innerHTML = "**Invalid Attachments (Only 'pdf,png,jpg' Supported)!";
            setTimeout(() => { document.getElementById("newPaymentFilesError").innerHTML = ""; }, 5000)
            return false;
          }
          else {
            this.myFiles.push(files[i]);
            this.listObj.attachmentName = files[i].name;
            this.detailList.push(this.listObj);
            this.listObj = new PaymentDocDetailsProperties();

          }
        }
      }

    }
    else if (eventTrigger == "drag") {
      const files = event.dataTransfer.files;
      if (files.length == 0) {
        return false;
      }
      else {
        for (let i = 0; i < files.length; i++) {
          const filename = event.dataTransfer.files[i].name;
          if (this.ValidateFileType(filename) == false) {
            document.getElementById("newPaymentFilesError").innerHTML = "**Invalid Attachments (Only 'pdf,png,jpg' Supported)!";
            setTimeout(() => { document.getElementById("newPaymentFilesError").innerHTML = ""; }, 5000)
            return false;
          }
          else {
            this.myFiles.push(files[i]);
            this.listObj.attachmentName = files[i].name;
            this.detailList.push(this.listObj);
            this.listObj = new PaymentDocDetailsProperties();
          }
        }
      }


    }
    this.obj.docList = this.detailList;
  }
  public ClearSelection = (index: number): void => {
    this.myFiles.splice(index, 1);
    this.detailList.splice(index, 1);
    this.obj.docList.splice(index, 1);
  }
  private ValidateFileType = (fileName: any): boolean => {
    var idxDot = fileName.lastIndexOf(".") + 1;
    var extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
    if (extFile == "jpeg" || extFile == "png" || extFile == "pdf" || extFile == "jpg") {
      this.ValidateFileFormat = true;
    } else {
      this.ValidateFileFormat = false;
    }
    return this.ValidateFileFormat;
  }
  public SubmitNewPayment = (formData: any): boolean => {
    this.newPaymentSubmitted = true;
    let submitValidation = true;
    if (formData.invalid) {
      document.getElementById("errorPaymentAdd").innerHTML = "**Please Enter Required Fields";
      document.getElementById("errorPaymentAdd").style.color = "#f44336";
      setTimeout(() => {
        document.getElementById("errorPaymentAdd").innerHTML = "";
        document.getElementById("errorPaymentAdd").style.color = "";
      }, 5000);
      return false;
    }
    else {
      if (this.obj.amount <= 0) {
        document.getElementById("errorPaymentAdd").innerHTML = "**Amount Should Be Grater Than '0'!";
        document.getElementById("errorPaymentAdd").style.color = "#f44336";
        setTimeout(() => {
          document.getElementById("errorPaymentAdd").innerHTML = "";
          document.getElementById("errorPaymentAdd").style.color = "";
        }, 5000);
        submitValidation = false;
        return false;
      }
      if (this.obj.modeOfPaymentId != 4) {
        if (this.myFiles.length == 0 || this.myFiles == null) {
          document.getElementById("errorPaymentAdd").innerHTML = "**Attachment Required!";
          document.getElementById("errorPaymentAdd").style.color = "#f44336";
          setTimeout(() => {
            document.getElementById("errorPaymentAdd").innerHTML = "";
            document.getElementById("errorPaymentAdd").style.color = "";
          }, 5000);
          submitValidation = false;
          return false;
        }
      }
      if (submitValidation == true) {
        this.primeShowModalSavePaymentModel = true;
      }
    }
  }
  public CloseProcessPaymentModel = (): void => {
    this.primeShowModalSavePaymentModel = false;
  }
  public ConfirmProcessPayment = (): void => {
    this.loaderConfimVar = true;
    this.obj.creationUser = Number(localStorage.getItem('UserId'));
    this.obj.branchId = localStorage.getItem('BranchId') || "";
    this.obj.agencyId = localStorage.getItem('AgencyId') || "";
    this.obj.status = "Requested";
    this.obj.creationUserBackCompanyId = Number(localStorage.getItem("BackSystemCompanyId"));
    this.obj.creationUserBackCustomer = localStorage.getItem("BackSystemCompanyCustomer");
    const formData = new FormData();
    formData.append("paymentObject", JSON.stringify(this.obj));
    for (var i = 0; i < this.myFiles.length; i++) {
      formData.append("file", this.myFiles[i]);
    }
    this.paymentResponseMessage = new PaymentResponseMessage();
    this.service.SavePaymentRequest(formData).subscribe(data => {
      this.paymentResponseMessage = data
      if (this.paymentResponseMessage.status == true) {
        if (this.obj.modeOfPaymentId == 4) {
          this.CloseProcessPaymentModel();
          this.loaderConfimVar = false;
          try {
            this.urls.srvFlr = this.urls.srvFlr + "?id=" + this.paymentResponseMessage.responseData;
            this.primeShowModalCreditCardPaymentModel = true;
            setTimeout(() => {
              this.UpdatedDateTime();
            }, 500);

          }
          catch (ex) {
            console.log(ex)
          }

        }
        else {
          this.CloseProcessPaymentModel();
          this.loaderConfimVar = false;
          this.primeShowModalSuccessModel = true;
        }

      }
      else {
        this.loaderConfimVar = false;
        this.CloseProcessPaymentModel();
        document.getElementById("errorPaymentAdd").innerHTML = this.paymentResponseMessage.message;
        document.getElementById("errorPaymentAdd").style.color = "#f44336";
        setTimeout(() => {
          document.getElementById("errorPaymentAdd").innerHTML = "";
          document.getElementById("errorPaymentAdd").style.color = "";
        }, 5000);
      }
    })
  }
  public ClosePaymentSuccessModel = (): void => {
    this.primeShowModalSuccessModel = false;
    this.ClearBack();
  }
  public DownLoadFile = (obj: PaymentDocDetailsProperties): void => {

    let fileDetail = new FileDownloadType();
    fileDetail.fullPath = obj.attachmentFilePath;
    let fileName = obj.attachmentName;
    let checkFileType = fileName.split('.').pop();
    checkFileType = "." + checkFileType;
    this.service.DownloadFile(obj.id).subscribe(blob => {
      importedSaveAs(blob.body, obj.attachmentName);
    });
  }
  public OpenRejectPaymentModel = (): boolean => {
    let rejectValidation: boolean;
    if (this.obj.reasonForRejection == null || this.obj.reasonForRejection == undefined || this.obj.reasonForRejection.trim() == "") {
      rejectValidation = false;
      document.getElementById("paymentTextArea").classList.add("remarksTextError");
      document.getElementById("remarksLabelError").classList.add("remarksLabelError");
      document.getElementById("newPaymentRemarksError").innerHTML = "**Please Enter Reason For Rejection!";
      setTimeout(() => {
        document.getElementById("paymentTextArea").classList.remove("remarksTextError");
        document.getElementById("remarksLabelError").classList.remove("remarksLabelError");
        document.getElementById("newPaymentRemarksError").innerHTML = "";
      }, 4000);
      return rejectValidation;
    }
    else {
      this.obj.reasonForRejection = this.obj.reasonForRejection.trim();
      rejectValidation = true;
      document.getElementById("paymentTextArea").classList.remove("remarksTextError");
      document.getElementById("remarksLabelError").classList.remove("remarksLabelError");
      document.getElementById("newPaymentRemarksError").innerHTML = "";
      this.primeShowModalRejectPaymentModel = true;
    }
    return rejectValidation;

  }
  public CloseRejectPaymentModel = (): void => {
    this.primeShowModalRejectPaymentModel = false;
  }
  public ConfirmRejectPayment = (): void => {

    this.obj.status = "Rejected";
    this.obj.approval_RejectionUser = Number(localStorage.getItem('UserId'));
    this.obj.approvingAgencyId = localStorage.getItem('AgencyId');
    this.obj.isApproved = false;
    this.loaderConfimVar = true;
    this.paymentResponseMessage = new PaymentResponseMessage();
    this.service.RejectPayment(this.obj).subscribe((res) => {
      this.paymentResponseMessage = res;
      if (this.paymentResponseMessage.status == true) {
        this.loaderConfimVar = false;
        this.CloseRejectPaymentModel();
        this.primeShowModalSuccessModel = true;
      }
      else {
        this.loaderConfimVar = false;
        this.CloseRejectPaymentModel();
        document.getElementById("errorPaymentAdd").innerHTML = this.paymentResponseMessage.message;
        document.getElementById("errorPaymentAdd").style.color = "#f44336";
        setTimeout(() => {
          document.getElementById("errorPaymentAdd").innerHTML = "";
          document.getElementById("errorPaymentAdd").style.color = "";
        }, 5000);
      }

    });
  }
  public OpenApprovePaymentModel = (): boolean => {
    let isValidate: boolean = true;
    if (this.obj.modeOfPaymentId == 1 && this.requesterImmediateParent == 'AG01') {
      if (this.obj.backSystemCompanyId == 0 || this.obj.backSystemCompanyId == null || this.obj.backSystemCompanyId == undefined) {
        document.getElementById("paymentBackSystemCompanyIdErrors").innerHTML = "**System Company Required!";
        document.getElementById("paymentBackSystemCompanyLabelErrors").classList.add("labelofmodifyserachinputsError");
        setTimeout(() => {
          document.getElementById("paymentBackSystemCompanyIdErrors").innerHTML = "";
          document.getElementById("paymentBackSystemCompanyLabelErrors").classList.remove("labelofmodifyserachinputsError");
        }, 5000)
      }
      if (this.obj.backSystemBranchName == null || this.obj.backSystemBranchName == undefined || this.obj.backSystemBranchName == "") {
        document.getElementById("newPaymentBackSystemBranchNameErrors").innerHTML = "**Branch Location Required!";
        document.getElementById("newPaymentBackSystemBranchNameLabelError").classList.add("labelofmodifyserachinputsError");
        setTimeout(() => {
          document.getElementById("newPaymentBackSystemBranchNameErrors").innerHTML = "";
          document.getElementById("newPaymentBackSystemBranchNameLabelError").classList.remove("labelofmodifyserachinputsError");
        }, 5000)

      }
      if ((this.obj.backSystemCompanyId == 0 || this.obj.backSystemCompanyId == null || this.obj.backSystemCompanyId == undefined)
        || (this.obj.backSystemBranchName == null || this.obj.backSystemBranchName == undefined || this.obj.backSystemBranchName == "")) {
        isValidate = false;
        return false;
      }
    }
    else if (this.obj.modeOfPaymentId == 2) {
      if (this.obj.accountNo == "" || this.obj.accountNo == null || this.obj.accountNo == undefined) {
        document.getElementById("newPaymentAccountNoErrors").innerHTML = "**Benificiary Account Required!";
        document.getElementById("newPaymentAccountNoLabelError").classList.add("labelofmodifyserachinputsError");
        setTimeout(() => {
          document.getElementById("newPaymentAccountNoErrors").innerHTML = "";
          document.getElementById("newPaymentAccountNoLabelError").classList.remove("labelofmodifyserachinputsError");
        }, 5000);
        isValidate = false;
        return false;
      }
    }
    if (isValidate == true) {
      this.primeShowModalApprovePaymentModel = true;
    }
  }
  public CloseApprovePaymentModel = (): void => {
    this.primeShowModalApprovePaymentModel = false;
  }
  public ConfirmApprovePayment = (): void => {

    this.obj.status = "Approved";
    this.obj.approval_RejectionUser = Number(localStorage.getItem('UserId'));
    this.obj.approvingAgencyId = localStorage.getItem('AgencyId');
    this.obj.isApproved = true;
    this.obj.url = environment.backSystemBaseUrl;
    this.obj.documentReference = this.originalReference + "-" + this.obj.documentReference;
    this.paymentResponseMessage = new PaymentResponseMessage();
    this.loaderConfimVar = true;
    this.service.ApprovePayment(this.obj).subscribe((response) => {
      this.paymentResponseMessage = response;
      if (this.paymentResponseMessage.status == true) {
        this.loaderConfimVar = false;
        this.CloseApprovePaymentModel();
        this.primeShowModalSuccessModel = true;
      }
      else {
        this.loaderConfimVar = false;
        this.CloseApprovePaymentModel();
        document.getElementById("errorPaymentAdd").innerHTML = this.paymentResponseMessage.message;
        document.getElementById("errorPaymentAdd").style.color = "#f44336";
        setTimeout(() => {
          document.getElementById("errorPaymentAdd").innerHTML = "";
          document.getElementById("errorPaymentAdd").style.color = "";
        }, 5000);
      }

    });
  }

  private UpdatedDateTime = (): void => {
    const timezone: string = $("#timezoneID").val() as string;
    $("#txndatetimeID").val(moment().tz(timezone).format('YYYY:MM:DD-HH:mm:ss'));
  }
  private GetIPGsURL = (): void => {
    this.service.getURLs().subscribe(data => {
      this.urls = data;
      // console.log(this.urls)
    });
  }
  public CreatePaymentLogs = (): void => {
    this.buttonIPGClick = true;
    var paymentForm;
    var environmentUrl = this.urls.url;
    const sharedSecret = this.urls.key;
     //const sharedSecret = 'n+Gs"37vQE';
    $("#paymentForm").submit(function (event) {
      paymentForm = $("#paymentForm");
      paymentForm.attr('action', String(environmentUrl));
      var paymentParameters = paymentForm.serializeArray().filter(function (item) {
        return item.value !== "";
      }).reduce(function (obj: any, item) {
        obj[item.name] = item.value;
        return obj;
      }, {});
      /* Prepare Message Signature Content */
      //const sharedSecret = environment.sharedSecrectKey;
      var messageSignatureContent: any[] = [];
      const ignoreSignatureParameteres = ["hashExtended"];
      Object.keys(paymentParameters).filter(key => !ignoreSignatureParameteres.includes(key)).sort().forEach(function (key, index) {
        messageSignatureContent.push(paymentParameters[key]);
      });
      /* Calculate Message Signature */
      const messageSignature = HmacSHA256(messageSignatureContent.join("|"), String(sharedSecret));
      const messageSignatureBase64 = Base64.stringify(messageSignature);
      $("#hashExtendedID").val(messageSignatureBase64);
    });

  }
  public CloseCreditCardPaymentSuccessModel = (): void => {
    this.primeShowModalCreditCardPaymentSuccessModel = false;
    this.router.navigateByUrl("/paymentList");
  }
  public CloseCreditCardPaymentFailModel = (): void => {
    this.DeletePayment(this.snapShotRouteId);
  }
  public CancelCreditCardPayment = (): void => {
    if (this.paymentResponseMessage.responseData != null) {
      this.service.CancelPayment(this.paymentResponseMessage.responseData).subscribe(() => {
        this.primeShowModalCreditCardPaymentModel = false;
        this.router.navigateByUrl("/paymentList");
      })
    }
  }
  public PrivewFile = (obj: PaymentDocDetailsProperties): void => {
    this.service.DownloadFile(obj.id).subscribe(blob => {
      if (obj.fileextension.includes("Image")) {
        let reader = new FileReader();
        reader.onloadend = () => {
          this.imagePreview = reader.result;
        };
        if (blob) {
          this.primeShowModalDisplayImage = true;
          reader.readAsDataURL(blob.body);
        }
      }
      else{
        this.imagePreview= this.senetizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob.body));
           window.open(this.imagePreview.changingThisBreaksApplicationSecurity,'_blank');
        };
    });
  }
  public CloseDisplyImageModel = (): void => {
    this.primeShowModalDisplayImage = false;
  }





































  /** PaymentAddEdit ctor */





  // public progress: number;
  // paymentloader: boolean = false;
  // public messageReturned: string = "";
  // public filePath: string;
  // public docNoReturned: number = 0;
  // idAssigned: boolean = false;
  // isReadOnly: boolean = false;
  // fileUrl;

  // baseUrl = environment.baseUrl;

  // inProgress: boolean = false;
  // paymentId: number = 0;



  // CheckPaymentRights() {
  //   this.service.CheckPaymentRights(localStorage.getItem('AgencyId'), localStorage.getItem('UserId')).subscribe((data) => {
  //     this.rightsObj = data;
  //     if (this.rightsObj.addPayment) {
  //       $("#btnSave").removeAttr("disabled");
  //     }
  //     else if (!this.rightsObj.addPayment) {
  //       $("#btnSave").attr("disabled", "disabled");
  //     }
  //     else if (this.rightsObj.approvePayment) {
  //       $("#btnApprove").removeAttr("disabled");
  //     }
  //     else if (!this.rightsObj.approvePayment) {
  //       $("#btnApprove").attr("disabled", "disabled");
  //     }
  //     else if (this.rightsObj.deletePayment) {
  //       $("#btnReject").removeAttr("disabled");
  //     }
  //     else if (!this.rightsObj.deletePayment) {
  //       $("#btnReject").attr("disabled", "disabled");
  //     }

  //   });
  // }

  // svg() {
  // }



  // showButtons() {
  //   let path: string = localStorage.getItem("fromRoute");
  //   if ((path == 'managerList') && (this.obj.status == "Requested")) {
  //     $("#btnApprove").show();
  //     $("#btnReject").show();
  //     $("#btnSave").hide();
  //     $("#btnCancel").hide();
  //     $("#imageuploadid").hide();
  //     // this.obj.inProcess = true;
  //     // this.managercheck = true;
  //     // this.service.UpdateInprocessTag(this.obj).subscribe((data) => {
  //     //   // console.log(data);
  //     // })
  //     // setTimeout(() => {
  //     //   this.obj.inProcess = false;

  //     //   this.service.UpdateInprocessTag(this.obj).subscribe((data) => {
  //     //     //   console.log(data);
  //     //   })
  //     // }, 600000)
  //   }
  //   else if ((path == 'managerList') && this.obj.status == "In Process") {
  //     $("#btnSave").hide();
  //     $("#btnCancel").hide();
  //     $("#btnApprove").show();
  //     $("#btnReject").show();
  //     $("#imageuploadid").hide();

  //   }
  //   else if ((path == 'managerList') && this.obj.status == "Rejected") {
  //     $("#btnApprove").hide();
  //     $("#btnReject").hide();
  //     $("#btnSave").hide();
  //     $("#imageuploadid").hide();
  //     $("#btnCancel").hide();

  //   }
  //   else if ((path == 'managerList') && this.obj.status == "Approved") {
  //     $("#btnApprove").hide();
  //     $("#btnReject").hide();
  //     $("#btnSave").hide();
  //     $("#imageuploadid").hide();
  //     $("#btnCancel").hide();

  //   }
  //   else if ((path == 'paymentList') && this.obj.status == "In Process") {
  //     $("#btnApprove").hide();
  //     $("#btnReject").hide();
  //     $("#btnSave").hide();
  //     $("#imageuploadid").hide();
  //     $("#btnCancel").hide();
  //   }
  //   else if ((path == 'paymentList' && this.obj.status == "Requested")) {
  //     $("#btnSave").hide();
  //     $("#btnCancel").hide();
  //     $("#btnApprove").hide();
  //     $("#imageuploadid").hide();
  //     $("#btnReject").hide()
  //   }
  //   else if ((path == 'paymentList') && (this.obj.status == "Rejected")) {
  //     $("#btnApprove").hide();
  //     $("#btnReject").hide();
  //     $("#imageuploadid").hide();
  //     $("#btnSave").hide();
  //     $("#btnCancel").hide();
  //   }
  //   else if ((path == 'paymentList') && (this.obj.status == "Approved")) {
  //     $("#btnApprove").hide();
  //     $("#btnReject").hide();
  //     $("#imageuploadid").hide();
  //     $("#btnSave").hide();
  //     $("#btnCancel").hide();
  //   }
  //   else {
  //     $("#btnApprove").hide();
  //     $("#btnReject").hide();


  //   }
  // }




  // uploadFiles() {
  //   let message;
  // //   this.paymentloader = true;
  //   const frmData = new FormData();
  //   frmData.append("agencyId", this.obj.agencyId);
  //   frmData.append("branchId", this.obj.branchId);
  //   frmData.append("modeOfPayment", this.obj.modeOfPaymentId.toString());
  //   frmData.append("amount", this.obj.amount.toString());
  //   frmData.append("benificiaryAccount", this.obj.accountNo);
  //   frmData.append("depositType", this.obj.depositTypeId.toString());
  //   frmData.append("paymentDate", this.obj.paymentDate);
  //   frmData.append("documentReference", this.obj.documentReference);
  //   frmData.append("creationUser", this.obj.creationUser.toString());
  //   frmData.append("reason", this.obj.reasonForRejection)

  //   frmData.append("paymentId", this.obj.paymentId.toString());
  //   frmData.append("status", this.obj.status);
  //   if (this.obj.paymentId != 0) {
  //     frmData.append("isApproved", this.obj.isApproved.toString());
  //     frmData.append("approvingAgencyId", this.obj.approvingAgencyId);
  //     frmData.append("backSystemPaymentId", this.obj.backSystemPaymentId.toString());
  //     frmData.append("approval_RejectionUser", this.obj.approval_RejectionUser.toString());
  //     frmData.append("approval_RejectionDateTime", this.obj.approval_RejectionDateTime);
  //     frmData.append("modifyUser", this.obj.modifyUser.toString());
  //   }
  //   for (var i = 0; i < this.myFiles.length; i++) {
  //     frmData.append("frmData", this.myFiles[i]);
  //   }

  //   const uploadReq = new HttpRequest('POST', this.baseUrl + '/Payment/UploadFiles', frmData, {
  //     reportProgress: true,

  //   });
  //   this.http.request(uploadReq).subscribe(event => {

  //     if (event.type === HttpEventType.UploadProgress) {
  //       this.progress = Math.round(100 * event.loaded / event.total);

  //     }
  //     else if (event.type === HttpEventType.Response) {

  //       this.messageReturned = event.body.toString();
  //       //console.log(this.messageReturned);
  //       // message = event.body.toString();


  //     }

  //     if (this.messageReturned == "Saved") {
  //       if (localStorage.getItem('fromRoute') == "paymentList") {
  //         localStorage.removeItem('fromRoute');
  //         this.router.navigateByUrl("/paymentList");
  //       }
  //       else if (localStorage.getItem('fromRoute') == 'managerList') {
  //         localStorage.removeItem('fromRoute');
  //         this.router.navigateByUrl("/managerPaymentList")
  //       }

  //       // localStorage.removeItem('fromRoute');

  //     }
  //     else if (this.messageReturned == "Failed") {
  //       $("#lblMessage").show();
  //       document.getElementById("lblMessage").innerHTML = "Something Went Wrong.";
  //       $(document.getElementById("lblMessage")).delay(1000).hide(500);
  //     }

  // //     this.paymentloader = false;

  //   })


  // }

  // Save() {
  //   try {
  //     if (this.obj.modeOfPaymentId == 0 || this.obj.modeOfPaymentId == null || this.obj.modeOfPaymentId == undefined) {
  //       document.getElementById("modepaymentmessage").innerHTML = "Required";
  //       setTimeout(() => { document.getElementById("modepaymentmessage").innerHTML = ""; }, 5000)
  //     }
  //     if (this.obj.accountNo == "" || this.obj.accountNo == null || this.obj.accountNo == undefined) {
  //       document.getElementById("Benificiarymessage").innerHTML = "Required";
  //       setTimeout(() => { document.getElementById("Benificiarymessage").innerHTML = ""; }, 5000)
  //     }
  //     if (this.obj.depositTypeId == 0 || this.obj.depositTypeId == null || this.obj.depositTypeId == undefined) {
  //       document.getElementById("Depositmessage").innerHTML = "Required";
  //       setTimeout(() => { document.getElementById("Depositmessage").innerHTML = ""; }, 5000)
  //     }
  //     if (this.obj.paymentDate == "" || this.obj.paymentDate == null || this.obj.paymentDate == undefined) {
  //       document.getElementById("PaymentDatemessage").innerHTML = "Required";
  //       setTimeout(() => { document.getElementById("PaymentDatemessage").innerHTML = ""; }, 5000)
  //     }
  //     if (this.obj.documentReference == "" || this.obj.documentReference == null || this.obj.documentReference == undefined) {
  //       document.getElementById("Documentmessage").innerHTML = "Required";
  //       setTimeout(() => { document.getElementById("Documentmessage").innerHTML = ""; }, 5000)
  //     }
  //     if (this.obj.amount == 0 || this.obj.amount == null || this.obj.amount == undefined) {
  //       document.getElementById("Amountmessage").innerHTML = "Required";
  //       setTimeout(() => { document.getElementById("Amountmessage").innerHTML = ""; }, 5000)
  //     }
  //     if (this.obj.modeOfPaymentId == 0 || this.obj.modeOfPaymentId == null || this.obj.modeOfPaymentId == undefined ||
  //       this.obj.accountNo == "" || this.obj.accountNo == null || this.obj.accountNo == undefined || this.obj.depositTypeId == 0
  //       || this.obj.depositTypeId == null || this.obj.depositTypeId == undefined || this.obj.paymentDate == "" ||
  //       this.obj.paymentDate == null || this.obj.paymentDate == undefined || this.obj.documentReference == "" || this.obj.documentReference == null
  //       || this.obj.documentReference == undefined || this.obj.amount == 0 || this.obj.amount == null || this.obj.amount == undefined) {
  //       return;
  //     }
  //     if (this.myFiles.length == 0) {
  //       document.getElementById("messageLogo1").innerHTML = "Required";
  //       setTimeout(() => { document.getElementById("messageLogo1").innerHTML = ""; }, 5000)
  //       return;
  //     }

  //     this.inProgress = true;
  //     document.getElementById("overlay").style.display = "block";
  //     //localStorage.setItem('UserId', '15');
  //     //localStorage.setItem('BranchId', 'AG02B01');
  //     //localStorage.setItem('AgencyId','AG02');
  //     const userId = Number(localStorage.getItem('UserId'));
  //     const branchId = localStorage.getItem('BranchId');
  //     const agencyId = localStorage.getItem('AgencyId');

  //     if (this.obj.paymentId != 0) {

  //       this.obj.modifyUser = Number(userId);
  //       this.obj.agencyId = agencyId;
  //       this.obj.branchId = branchId;

  //       this.uploadFiles();
  //       this.inProgress = false;
  //       document.getElementById("overlay").style.display = "none";



  //     }

  //     else {

  //       this.obj.creationUser = Number(userId);
  //       this.obj.agencyId = agencyId;
  //       this.obj.branchId = branchId;
  //       this.obj.status = "Requested";

  //       this.uploadFiles();
  //       this.inProgress = false;
  //       document.getElementById("overlay").style.display = "none";

  //     }


  //   }
  //   catch (ex) { }
  // }
  // Cancel() {
  //   this.obj = new PaymentProperties();
  //   this.obj.docList = [];
  //   this.myFiles = [];
  // }


  // Approve() {
  //   this.inProgress = true;
  //   document.getElementById("overlay").style.display = "block";
  //   this.obj.status = "Approved";
  //   this.obj.approval_RejectionUser = Number(localStorage.getItem('UserId'));
  //   this.obj.approvingAgencyId = localStorage.getItem('AgencyId');
  //   this.obj.isApproved = true;
  //   this.obj.url = environment.backSystemBaseUrl;
  //   // this.paymentloader = true;
  //   this.service.approvePayment(this.obj).subscribe((data2) => {
  //     /*    console.log(data2);*/
  //     // this.paymentloader = false;
  //     document.getElementById("overlay").style.display = "none";
  //     if (data2 == true) {
  //       let aba = new AgencyBranchApprovalProperties();
  //       aba.agencyId = this.obj.agencyId;
  //       aba.accountNumber = this.obj.accountNo;
  //       aba.amount = this.obj.amount;
  //       aba.paymentId = this.obj.paymentId;
  //       this.service.ApprovalAgencyBranchCreditLimitS(aba).subscribe((data) => {
  //         //console.log(data);
  //         this.inProgress = false;
  //         this.router.navigateByUrl('/managerPaymentList');

  //       })
  //     }

  //     else {
  //       $("#lblMessage").show();
  //       document.getElementById("lblMessage").innerHTML = "Something Went Wrong.";
  //       $(document.getElementById("lblMessage")).delay(1000).hide(500);
  //     }

  //   });
  // }


}
